<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[$t('menu.bargains'), $t('text.create')]"
      ></breadcrumb>
      <div class="container">
        <el-steps
          :active="1"
          finish-status="success"
          simple
          class="create-bargain-step"
        >
          <el-step title="添加订单"></el-step>
          <el-step title="添加产品(大货)"></el-step>
          <el-step title="添加收款"></el-step>
        </el-steps>
        <div class="mg20">
          <fieldset>
            <legend class="center">
              <span class="float-left">{{ $t("text.baseInfo") }}</span>
              <span v-if="$route.query.payBalance == 'true'" class="red">
                {{ $t("customer.balance")
                }}{{ $route.query.customerBalance | currency }}
              </span>
              <el-button
                size="mini"
                @click="triggerImport"
                class="float-right"
                plain
                >{{ isImport ? "输入" : "导入" }}</el-button
              >
            </legend>
          </fieldset>
          <div v-if="isImport">
            <div class="import">
              <ul class="orange">
                <li class="explain">{{ $t("newImportBulk.excelTitle") }}</li>
                <li class="explain">
                  {{ $t("newImport.excelTemplate") }}:
                  <a :href="excelTemplate" target="_blank">{{
                    $t("newImport.clickDownload")
                  }}</a>
                </li>
                <li class="explain">
                  {{ $t("newImport.beCareful") }}：1、{{
                    $t("newImport.beCarefulMustFill")
                  }}
                </li>
                <li class="beCareful">
                  2、{{ $t("newImportProduct.beCarefulImages") }}
                </li>
              </ul>
            </div>
            <div class="center">
              <el-upload
                ref="upload"
                :action="url"
                :headers="fileHeaders"
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
                :on-success="importResult"
                accept=".xls, .xlsx"
              >
                <el-button
                  type="success"
                  size="small"
                  style="width: 100px"
                  :loading="importLoading"
                  >{{ $t("action.import") }}</el-button
                >
              </el-upload>
            </div>

            <div v-if="importResults.length != 0" class="mgt5">
              <span class="mgl15"
                >{{ $t("newImport.results") }}：<span class="red">{{
                  importText
                }}</span></span
              >
              <ol class="import">
                <li
                  v-for="(r, index) of importResults"
                  :key="index"
                  class="explain"
                >
                  <span v-if="r.type == 'fail'" class="grey">{{
                    r.message
                  }}</span>
                  <span v-if="r.type == 'success'" class="green">{{
                    r.message
                  }}</span>
                </li>
              </ol>
            </div>
            <div v-if="importSameSerialNosLocal.length != 0" class="mgt5">
              <span class="mgl15"
                >重复单号：<span class="red">{{ importText }}</span></span
              >
              <ol class="import">
                <li
                  v-for="(r, index) of importSameSerialNosLocal"
                  :key="index"
                  class="explain"
                >
                  <span class="orange">{{ r }}</span>
                </li>
              </ol>
            </div>
            <div v-if="importSameSerialNosInv.length != 0" class="mgt5">
              <span class="mgl15"
                >订单已存在的单号：<span class="red">{{
                  importText
                }}</span></span
              >
              <ol class="import">
                <li
                  v-for="(r, index) of importSameSerialNosInv"
                  :key="index"
                  class="explain"
                >
                  <span class="orange">{{ r }}</span>
                </li>
              </ol>
            </div>
            <div
              v-if="importOrders.length != 0"
              class="center blue mgt10 font18"
            >
              {{ importText }}
            </div>
          </div>
          <template v-else>
            <div
              class="flex flex-between mgb10"
              v-for="(order, index) in orders"
              :key="index"
            >
              <div class="mgr10">
                <thumbnail :images="order.images" />
              </div>
              <div class="flex-grow">
                <el-row :gutter="20">
                  <el-col :span="19">
                    <el-row :gutter="20" class="mgb10">
                      <el-col :span="6">
                        <el-input
                          size="small"
                          v-model.trim="order.serialNo"
                          :placeholder="
                            $t('rules.mustFillSimple', [$t('order.serialNo')])
                          "
                          @blur="blurOrderSerialNo(index)"
                        ></el-input>
                      </el-col>
                      <el-col :span="6">
                        <el-autocomplete
                          size="small"
                          v-model.trim="order.productNo"
                          :fetch-suggestions="querySearchProductNo"
                          :data-index="index"
                          :trigger-on-focus="false"
                          style="width: 100%"
                          :placeholder="
                            $t('rules.mustFillSimple', [
                              $t('product.productNo'),
                            ])
                          "
                          @focus="getFoucs(index)"
                          @select="handleSelectProductNo(index)"
                        >
                          <template slot-scope="{ item }">
                            <div class="name">{{ item.productNo }}</div>
                            <span class="addr">{{ item.productNoAlias }}</span>
                          </template>
                        </el-autocomplete>
                      </el-col>
                      <el-col :span="6">
                        <el-autocomplete
                          size="small"
                          v-model.trim="order.color"
                          :fetch-suggestions="querySearchColor"
                          :placeholder="$t('product.color')"
                          style="width: 100%"
                          @focus="getFoucs(index)"
                          @select="handleSelectColor(index)"
                        ></el-autocomplete>
                      </el-col>
                      <el-col :span="6">
                        <el-autocomplete
                          size="small"
                          v-model.trim="order.size"
                          :fetch-suggestions="querySearchSize"
                          :placeholder="$t('product.size')"
                          style="width: 100%"
                          @focus="getFoucs(index)"
                          @select="handleSelectSize(index)"
                        ></el-autocomplete>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="6">
                        <el-input
                          size="small"
                          v-model.trim="order.quantity"
                          :placeholder="
                            $t('rules.mustFillSimple', [$t('text.quantity')])
                          "
                          @blur="computeTotalAmount"
                        ></el-input>
                      </el-col>
                      <el-col :span="6">
                        <el-input
                          size="small"
                          v-model.trim="order.price"
                          :placeholder="
                            $t('rules.mustFillSimple', [
                              $t('order.price') + '(' + currencySymbol + ')',
                            ])
                          "
                          @blur="blurPrice(index)"
                        ></el-input>
                      </el-col>
                      <el-col :span="6">
                        <el-input
                          size="small"
                          v-model.trim="order.discountRate"
                          :placeholder="$t('order.discountRate')"
                          @blur="blurDiscountRate(index)"
                        >
                          <div slot="append">%</div>
                        </el-input>
                      </el-col>
                      <el-col :span="6" class="font10">
                        <template v-if="order.productPrice != null" class="mgr5"
                          >{{ $t("order.productPriceSimple") }}:
                          {{ currencySymbol }}{{ order.productPrice }}</template
                        >
                        {{ $t("order.subtotal") }}:{{ currencySymbol
                        }}{{ Util.toFixed(order.price * order.quantity, 2) }}
                        <div class="font10">
                          <template
                            v-if="order.categoryName != null"
                            class="mgr5"
                            >{{ order.categoryName }}</template
                          >
                          <template
                            v-if="order._productBrand != null"
                            class="mgr5"
                            >/{{ order._productBrand }}</template
                          >
                          <el-popover
                            v-if="Permit.extendModels().includes('wms')"
                            placement="right"
                            width="500"
                            trigger="click"
                            @show="getInvInfo(index)"
                          >
                            <vxe-table
                              :data="invInfos"
                              id="invInfosTable"
                              row-id="id"
                              ref="recordsTable"
                              class="recordsTable"
                              size="mini"
                              resizable
                              round
                              auto-resize
                              highlight-hover-row
                              :scroll-y="{ enabled: false }"
                            >
                              <vxe-table-column
                                field="shopName"
                                :title="$t('menu.warehouses')"
                              />
                              <vxe-table-column
                                field="productNo"
                                :title="$t('product.productNo')"
                              />
                              <vxe-table-column
                                field="color"
                                :title="$t('product.color')"
                              />
                              <vxe-table-column
                                field="size"
                                :title="$t('product.size')"
                              />
                              <vxe-table-column
                                field="quantity"
                                :title="$t('inventory.quantity')"
                              />
                              <vxe-table-column
                                field="totalLock"
                                :title="$t('inventory.totalLock')"
                              />
                            </vxe-table>
                            <small
                              slot="reference"
                              class="blue popover-reference"
                              >{{ $t("menu.inventories") }}</small
                            >
                          </el-popover>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row
                      :gutter="20"
                      class="mgb10"
                      v-if="order._productNoAttributes.length != 0"
                    >
                      <el-col
                        :span="6"
                        v-for="(
                          attribute, attributeIndex
                        ) of order._productNoAttributes"
                        :key="attributeIndex"
                      >
                        <el-input
                          size="small"
                          v-model.trim="attribute.value"
                          :placeholder="attribute.name"
                        ></el-input>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="5">
                    <el-input
                      type="textarea"
                      :rows="3"
                      :placeholder="$t('text.remark')"
                      v-model="order.remark"
                    ></el-input>
                  </el-col>
                </el-row>
              </div>
              <div class="remove-order">
                <el-button
                  type="text"
                  size="small"
                  @click="removeOrder(index)"
                  v-if="index != 0"
                  >{{ $t("text.remove") }}</el-button
                >
              </div>
            </div>
            <div class="green">
              累计合计：{{ totalProductNoQty }} 款 {{ totalProductQty }} 件
              金额：{{ currencySymbol }}{{ totalAmount || 0 }}
            </div>

            <div class="center">
              <el-button
                v-if="orders.length < 10"
                type="info"
                @click="addOrder"
                plain
                round
                >{{ $t("action.addProduct") }}</el-button
              >
              <span v-else class="orange">
                {{ $t("prompt.addMorePrompt") }}
              </span>
            </div>
          </template>
        </div>
        <div class="form-footer">
          <el-row>
            <el-col :span="8" class="left">
              <div class="mgl10">
                <el-checkbox v-model="ignoreDF">忽略本次添加产品</el-checkbox>
              </div>
            </el-col>
            <el-col :span="8" class="center">
              <el-button
                type="success"
                size="medium"
                :loading="saveDoing"
                :disabled="saveDoing"
                @click="save('custom')"
                plain
                >+ {{ $t("orderTypes.custom") }}</el-button
              >
              <el-button
                v-if="Permit.currentTenant().config.bulkOrder"
                type="primary"
                size="medium"
                :loading="saveDoing"
                :disabled="saveDoing"
                @click="save('bulkOrder')"
                plain
                >+ {{ $t("orderTypes.bulk") }}</el-button
              >
              <el-button
                v-if="!Permit.currentTenant().config.bulkOrder"
                type="primary"
                size="medium"
                :loading="saveDoing"
                :disabled="saveDoing"
                @click="save('bulk')"
                plain
                >+ {{ $t("orderTypes.bulk") }}</el-button
              >
              <el-button
                type="warning"
                size="medium"
                :loading="saveDoing"
                :disabled="saveDoing"
                @click="save('wholesale')"
                plain
                >+ {{ $t("orderTypes.wholesale") }}</el-button
              >
            </el-col>
            <el-col :span="8" class="right">
              产品添加完成
              <el-button
                type="danger"
                size="medium"
                class="mgr10"
                :loading="saveDoing"
                :disabled="saveDoing"
                @click="save('payment')"
                plain
                >+ {{ $t("action.payment") }}</el-button
              >
            </el-col>
          </el-row>
        </div>
        <div
          class="wrapper"
          v-if="
            bargain != null &&
            bargain.orders != null &&
            bargain.orders.length != 0
          "
        >
          <newed-orders
            :bargain="bargain"
            :currencySymbol="currencySymbol"
            :updateDataDF="true"
            @updateData="newedOrdersEdit"
          ></newed-orders>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ls from "store2";
import { page } from "@/utils/mixins.js";
import { coreEndpoint, fileserverEndpoint } from "@/settings";
import Cookies from "@/utils/cookies.js";
import Thumbnail from "@/components/Thumbnail/index.vue";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber/index.vue";
import Util from "@/utils/index.js";
import Bargain from "@/api/bargain.js";
import Size from "@/api/size.js";
import Color from "@/api/color.js";
import Category from "@/api/category.js";
import Product from "@/api/product.js";
import Order from "@/api/order.js";
import Quotation from "@/api/quotation.js";
import Inventory from "@/api/inventory.js";
import NewedOrders from "./newedOrders";

function buildOrder() {
  return {
    serialNo: null,
    productNo: null,
    categoryId: null,
    categoryName: null,
    color: null,
    colorImage: null,
    size: null,
    quantity: null,
    productPrice: null,
    price: null,
    unit: null,
    images: null,
    specJson: null,
    craftwork: null,
    attachment: null,
    remark: null,
    bargainId: null,
    settlementId: null,
    currency: null,
    handOverAt: null,
    hurry: false,
    confirmAt: null,
    innerSerialNo: null,
    customerProductNo: null,
    extraCharge: null,
    discountRate: null,
    dealSuggest: null,
    type: null,
    createAt: null,
    productBrand: null,
    //
    _categorySizes: [],
    _productNoSizes: [],
    _productNoColors: [],
    //
    _productSizePrices: [],
    _productWholesalePrice: null,
    _productSalesPrice: null,
    _productSalesCurrency: null,
    _productSalesCnyRate: null,
    _productSalesCurrencySymbol: null,
    _quotationPrice: null,
    _quotationSizePrices: [],
    _CNYPrice: null,
    //
    _oldSizeExplain: null,
    _productIntroduction: null,
    _productLabels: [],
    _productBrand: null,
    _productNoAttributes: [],
  };
}
export default {
  mixins: [page],
  components: {
    Thumbnail,
    RawHtmlLimitNumber,
    NewedOrders,
  },
  data() {
    return {
      Util: Util,
      isImport: true,
      bargain: null,
      cnyRate: null,
      currencySymbol: null,
      sizes: [],
      colors: [],
      orders: [buildOrder(), buildOrder(), buildOrder()],
      invInfos: [],
      ignoreDF: false,
      saveDoing: false,
      // 导入
      excelTemplate:
        fileserverEndpoint +
        "/public/excelTemplates/jy_importOrderProducts.xlsx",
      url: coreEndpoint + "/excels/import-orders",
      fileHeaders: {
        type: "web",
        token: Cookies.getToken(),
      },
      importOrders: [],
      importSameSerialNosInv: [],
      importSameSerialNosLocalDF: false,
      importSameSerialNosInvDF: false,
      importLoading: false,
      // 累计合计
      totalProductNoQty: null,
      totalProductQty: null,
      totalAmount: null,

      importText: null,
      importResults: [],
      importSameSerialNosLocal: [],
      importShowTotal: 100,
    };
  },
  created() {
    const self = this;
    axios
      .all([
        Bargain.findByUuid({ uuid: self.$route.query.bargainUuid }),
        Category.findByTenantId(),
        Size.findByTenantId(),
        Color.findByTenantId(),
      ])
      .then(
        axios.spread(function (bargain, categories, sizes, colors) {
          if (bargain.status === 200) {
            self.bargain = bargain.data.entity;
            for (let i = 0; i < self.orders.length; i++) {
              self.orders[i].serialNo =
                self.bargain.serialNo +
                "-" +
                Number(self.bargain.orders.length + i + 1);
            }
            self.computeTotalAmount();

            // 币种
            const currentCurrencies = ls.session("CURRENCIES");
            const currencyObj = currentCurrencies.find(
              (c) => c.code === self.bargain.currency
            );
            if (currencyObj != null) {
              self.cnyRate = currencyObj.cnyRate;
              self.currencySymbol = currencyObj.symbol;
            } else {
              self.cnyRate = 1;
              self.currencySymbol = self.bargain.currency;
            }
          } else {
            self.sysError();
          }
          if (categories.status === 200) {
            self.categories = categories.data;
          } else {
            self.sysError();
          }
          if (sizes.status === 200) {
            self.sizes = sizes.data;
          } else {
            self.sysError();
          }
          if (colors.status === 200) {
            self.colors = colors.data;
          } else {
            self.sysError();
          }
        })
      );
  },

  methods: {
    newedOrdersEdit() {
      const self = this;
      Bargain.findByUuid({ uuid: self.bargain.uuid }).then(function (res) {
        if (res.status === 200) {
          self.bargain = res.data.entity;
          self.computeTotalAmount();
        } else {
          self.sysError();
        }
      });
    },
    computeTotalAmount() {
      const self = this;
      const validOrders = JSON.parse(JSON.stringify(self.orders)).filter(
        (o) =>
          o.productNo !== null &&
          o.productNo !== "" &&
          o.quantity !== null &&
          o.quantity !== "" &&
          o.price !== null &&
          o.price !== ""
      );
      let newProductNos = [];
      let newProductQty = 0;
      let newAmount = 0;
      if (validOrders.length != 0) {
        for (const order of validOrders) {
          newProductNos.push(order.productNo);
          newProductQty = newProductQty + Number(order.quantity);
          newAmount =
            newAmount + Number(Util.toFixed(order.price * order.quantity, 2));
        }
      }
      if (self.bargain != null && self.bargain.orders.lengt != 0) {
        let bargainProductNos = self.bargain.orders.map((o) => o.productNo);
        self.totalProductNoQty = [
          ...new Set(newProductNos.concat(bargainProductNos)),
        ].length;
        self.totalProductQty = newProductQty + Number(self.bargain.productQty);
        self.totalAmount = newAmount + Number(self.bargain.amount);
      } else {
        self.totalProductNoQty = [...new Set(newProductNos)].length;
        self.totalProductQty = newProductQty;
        self.totalAmount = newAmount;
      }
    },
    triggerImport() {
      this.isImport = !this.isImport;
    },
    // 导入==========================
    beforeAvatarUpload(file) {
      this.importSameSerialNosLocalDF = false;
      this.importSameSerialNosInvDF = false;
      this.importOrders = [];
      this.importSameSerialNosLocal = [];
      this.importSameSerialNosInv = [];
      this.importLoading = true;
      return true;
    },
    importResult(res, file) {
      const self = this;
      self.importSameSerialNosLocalDF = false;
      self.importSameSerialNosInvDF = false;
      self.importOrders = [];
      self.importSameSerialNosLocal = [];
      self.importSameSerialNosInv = [];
      this.importLoading = false;
      if (res && res != null) {
        if (res.failQuantity !== 0) {
          self.importText =
            "导入失败,共导入 " +
            res.allQuantity +
            " 条, " +
            res.failQuantity +
            " 条有问题";
          let detail = "";
          if (res.failQuantity.length > self.importShowTotal) {
            detail = ",仅展示前" + self.importShowTotal + "条错误信息";
          }
          self.importResults = res.results;
          self.$message({
            dangerouslyUseHTMLString: true,
            message: self.importText + detail,
            type: "warning",
          });
          return;
        }
        if (res.datas && res.datas.length != 0) {
          let orderSerialNos = [];
          self.importSameSerialNosLocal = [];
          let datas = [];
          for (const order of res.datas) {
            if (!orderSerialNos.includes(order.serialNo)) {
              orderSerialNos.push(order.serialNo);
            } else {
              self.importSameSerialNosLocal.push(order.serialNo);
            }
            const obj = {
              serialNo: order.serialNo,
              productNo: order.productNo,
              quantity: order.quantity,
              unit: order.unit,
              price: order.price,
              handOverAt: order.handOverAt,
              categoryId: order.categoryId,
              categoryName: order.categoryName,
              color: order.color,
              colorImage: order.colorImage,
              size: order.size,
              specJson: order.specJson,
              remark: order.remark,
              currency: self.bargain.currency,
              craftwork: order.craftwork,
              attachment: order.attachment,
              hurry: self.$route.query.hurry,
              images: order.images,
              type: null,
              _productBrand: order.productBrand,
              productBrand: order.productBrand,
              ///====
              productPrice: null,
              bargainId: self.bargain.id,
              settlementId: null,
              confirmAt: null,
              innerSerialNo: order.innerSerialNo,
              customerProductNo: order.customerProductNo,
              extraCharge: null,
              discountRate: null,
              dealSuggest: null,
            };
            datas.push(obj);
          }

          self.importSameSerialNosLocalDF = false;
          self.importSameSerialNosInvDF = false;
          //==
          if (self.importSameSerialNosLocal.length != 0) {
            self.importSameSerialNosLocalDF = true;
            self.importText =
              "导入失败,共导入 " +
              datas.length +
              " 条, " +
              self.importSameSerialNosLocal.length +
              " 条重复单号";
            let detail = "";
            if (self.importSameSerialNosLocal.length > self.importShowTotal) {
              detail = ",仅展示前" + self.importShowTotal + "条错误信息";
            }
            self.$message({
              dangerouslyUseHTMLString: true,
              message: self.importText + detail,
              type: "warning",
            });
            return;
          }
          // ==
          Order.findBySerialNos(orderSerialNos).then(function (res) {
            if (res.status == 200) {
              self.importSameSerialNosInv = res.data;
              if (self.importSameSerialNosInv.length !== 0) {
                self.importSameSerialNosInvDF = true;
                self.importText =
                  "导入失败,共导入 " +
                  datas.length +
                  " 条, " +
                  self.importSameSerialNosInv.length +
                  " 条订单已存在的单号";
                let detail = "";
                if (
                  self.importSameSerialNosLocal.length > self.importShowTotal
                ) {
                  detail = ",仅展示前" + self.importShowTotal + "条错误信息";
                }
                self.$message({
                  dangerouslyUseHTMLString: true,
                  message: self.importText + detail,
                  type: "warning",
                });
              } else {
                self.importSameSerialNosInvDF = false;
                self.importOrders = datas;
                self.importText =
                  "导入成功，共导入" + self.importOrders.length + "条数据";
                self.$message({
                  dangerouslyUseHTMLString: true,
                  message: self.importText,
                  type: "success",
                });
              }
            } else {
              self.sysError();
            }
          });
        }
      }
    },
    //==============================
    addOrder() {
      const newBuildOrder = JSON.parse(JSON.stringify(buildOrder()));
      newBuildOrder.serialNo =
        this.bargain.serialNo +
        "-" +
        (this.bargain.orders.length + this.orders.length + 1);
      this.orders.push(newBuildOrder);
    },
    removeOrder(idx) {
      this.orders.splice(idx, 1);
    },
    //
    blurOrderSerialNo(index) {
      const self = this;
      if (
        self.orders[index].serialNo === null ||
        self.orders[index].serialNo === ""
      ) {
        self.$message({
          message: self.$t("rules.required", [self.$t("order.serialNo")]),
          type: "warning",
        });
        return;
      }
      if (!Util.regexAlphabetNumberLine(self.orders[index].serialNo)) {
        self.$message({
          message: self.$t("prompt.regexAlphabetNumberLine"),
          type: "warning",
        });
        return;
      }
      // 前台本地过滤
      const iis = self.orders.filter(function (ii) {
        return ii.serialNo === self.orders[index].serialNo;
      });
      if (iis.length > 1) {
        self.$message({
          message: self.$t("rules.exist", [self.$t("order.serialNo")]),
          type: "warning",
        });
        self.orders[index].serialNo = null;
        return;
      }
      Order.findBySerialNo({
        serialNo: self.orders[index].serialNo,
      }).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("rules.exist", [self.$t("order.serialNo")]),
            type: "warning",
          });
          self.orders[index].serialNo = null;
        }
      });
    },
    //
    // 货号
    querySearchProductNo(queryString, cb) {
      const self = this;
      // self.customerQuotedDF = false;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      Product.vagueFindByProductNo({ productNo: queryString }).then(function (
        res
      ) {
        const ps = res.data;
        ps.forEach((p) => (p.value = p.productNo));
        self.products = ps;
        cb(self.products);
      });
    },
    handleSelectProductNo(idx) {
      const self = this;
      const item = self.products.find(
        (p) => p.productNo === self.orders[idx].productNo
      );
      self.orders[idx].productNo = item.productNo;
      self.orders[idx].categoryId = item.categoryId;
      self.orders[idx].categoryName = item.categoryName;
      self.selsectCategory(idx);
      self.orders[idx].color = null;
      self.orders[idx].colorImage = null;
      self.orders[idx].size = null;
      self.orders[idx].images = item.images;
      self.orders[idx].unit = item.unit;
      self.orders[idx].craftwork = item.craftwork;
      self.orders[idx].remark =
        (self.orders[idx].remark || "") + (item.introduction || "");
      self.orders[idx].discountRate = null;
      self.orders[idx]._productNoColors = item.colors;
      self.orders[idx]._productNoSizes = item.sizes;
      self.orders[idx]._productIntroduction = item.introduction;
      self.orders[idx]._productLabels = item.productLabels;
      self.orders[idx]._productBrand = item.brand;
      self.orders[idx].productBrand = item.brand;

      //
      self.orders[idx]._productSizePrices = item.productSizePrices;
      self.orders[idx]._productWholesalePrice = item.wholesalePrice;
      self.orders[idx]._productSalesPrice = item.salesPrice;
      self.orders[idx]._productSalesCurrency = item.salesCurrency;

      if (item.customAttributeJson != null && item.customAttributeJson != "") {
        self.orders[idx]._productNoAttributes = JSON.parse(
          item.customAttributeJson
        ).map((c) => {
          return { name: c, value: null };
        });
      } else {
        self.orders[idx]._productNoAttributes = [];
      }
      self.getQuotationPrice(idx);
      self.computeTotalAmount();
    },
    getQuotationPrice(idx) {
      const self = this;
      if (
        self.orders[idx].productNo != null &&
        self.orders[idx].productNo != ""
      ) {
        Quotation.findByCustomerIdAndProductNo(self.bargain.customerId, {
          productNo: self.orders[idx].productNo,
        }).then(function (res) {
          if (res.data.code === 200) {
            self.orders[idx]._quotationPrice = res.data.entity.price;
            self.orders[idx]._quotationSizePrices =
              res.data.entity.quotationSizePrices;
          } else {
            self.orders[idx]._quotationPrice = null;
            self.orders[idx]._quotationSizePrices = [];
          }
          self.computeCNYPrice(idx);
        });
      }
    },
    computeCNYPrice(idx) {
      const self = this;
      // 产品对客户的规格报价
      if (
        self.orders[idx]._quotationSizePrices.length != 0 &&
        self.orders[idx]._quotationSizePrices.find(
          (p) => p.size == self.orders[idx].size
        ) != null &&
        self.orders[idx]._quotationSizePrices.find(
          (p) => p.size == self.orders[idx].size
        ).price != null
      ) {
        self.orders[idx]._CNYPrice = self.orders[idx]._quotationSizePrices.find(
          (p) => p.size == self.orders[idx].size
        ).price;
        self.computeRatePrice(idx);
        return;
      }
      // 产品对客户的报价
      if (self.orders[idx]._quotationPrice !== null) {
        self.orders[idx]._CNYPrice = self.orders[idx]._quotationPrice;
        self.computeRatePrice(idx);
        return;
      }
      // 产品规格批发价格
      if (
        self.bargain.customerType === "wholesale" &&
        self.orders[idx]._productSizePrices.length != 0 &&
        self.orders[idx]._productSizePrices.find(
          (s) => s.size === self.orders[idx].size
        ) &&
        self.orders[idx]._productSizePrices.find(
          (s) => s.size === self.orders[idx].size
        ).wholesalePrice != null
      ) {
        self.orders[idx]._CNYPrice = self.orders[idx]._productSizePrices.find(
          (s) => s.size === self.orders[idx].size
        ).wholesalePrice;
        self.computeRatePrice(idx);
        return;
      }
      // 产品规格批发价格
      if (
        self.bargain.customerType === "wholesale" &&
        self.orders[idx]._productWholesalePrice != null &&
        self.orders[idx]._productWholesalePrice != 0
      ) {
        self.orders[idx]._CNYPrice = self.orders[idx]._productWholesalePrice;
        self.computeRatePrice(idx);
        return;
      }

      // 产品销售价币种
      const currentCurrencies = ls.session("CURRENCIES");
      const currencyObj = currentCurrencies.find(
        (c) => c.code === self.orders[idx]._productSalesCurrency
      );
      if (currencyObj != null) {
        self.orders[idx]._productSalesCnyRate = currencyObj.cnyRate;
        self.orders[idx]._productSalesCurrencySymbol = currencyObj.symbol;
      } else {
        self.orders[idx]._productSalesCnyRate = 1;
        self.orders[idx]._productSalesCurrencySymbol =
          self.productSalesCurrency;
      }
      // 产品规格售价
      if (
        self.orders[idx]._productSizePrices.length != 0 &&
        self.orders[idx]._productSizePrices.find(
          (s) => s.size === self.orders[idx].size
        ) &&
        self.orders[idx]._productSizePrices.find(
          (s) => s.size === self.orders[idx].size
        ).salesPrice != null
      ) {
        self.orders[idx]._CNYPrice =
          self.orders[idx]._productSizePrices.find(
            (s) => s.size === self.orders[idx].size
          ).salesPrice * self.orders[idx]._productSalesCnyRate;
        self.computeRatePrice(idx);
        return;
      }
      // 产品售价
      self.orders[idx]._CNYPrice =
        self.orders[idx]._productSalesPrice *
        self.orders[idx]._productSalesCnyRate;
      self.computeRatePrice(idx);
      return;
    },
    computeRatePrice(idx) {
      const self = this;
      // console.log("======computeRatePrice", self.orders[idx]._CNYPrice);
      if (self.orders[idx]._CNYPrice != null) {
        self.orders[idx].productPrice =
          Math.floor((self.orders[idx]._CNYPrice / self.cnyRate) * 100) / 100;
        self.orders[idx].price =
          Math.floor((self.orders[idx]._CNYPrice / self.cnyRate) * 100) / 100;
      } else {
        self.orders[idx].productPrice = null;
        self.orders[idx].price = null;
      }
    },
    //
    selsectCategory(idx) {
      const self = this;
      // console.log("===selsectCategory:", idx, self.orders[idx].categoryId);
      if (self.orders[idx].categoryId === "") {
        self.orders[idx].categoryId = null;
      }
      self.orders[idx]._categorySizes = [];
      if (
        self.orders[idx].categoryId != null &&
        self.orders[idx].categoryId !== ""
      ) {
        const selsectCategoryObj = self.categories.find(
          (c) => c.id === self.orders[idx].categoryId
        );
        if (
          selsectCategoryObj &&
          selsectCategoryObj.sizes != null &&
          selsectCategoryObj.sizes.length !== 0
        ) {
          self.orders[idx]._categorySizes = selsectCategoryObj.sizes;
        }
      }
    },
    //
    // 颜色
    querySearchColor(queryString, cb) {
      const self = this;
      const colors =
        self.orders[self.currentIndex]._productNoColors.length !== 0
          ? self.orders[self.currentIndex]._productNoColors.map((pc) => {
              return { value: pc };
            })
          : self.colors.map((c) => {
              return { value: c.name };
            });
      if (queryString == null) {
        cb(colors);
      } else {
        cb(colors.filter((c) => c.value.indexOf(queryString) !== -1));
      }
    },
    handleSelectColor(idx) {
      this.orders[idx].color = Util.jyTrim(this.orders[idx].color);
    },
    // 规格
    querySearchSize(queryString, cb) {
      const self = this;
      let sizes = [];
      if (self.orders[self.currentIndex]._productNoSizes.length !== 0) {
        sizes = self.orders[self.currentIndex]._productNoSizes.map((pc) => {
          return { value: pc };
        });
      } else {
        if (self.orders[self.currentIndex]._categorySizes.length !== 0) {
          sizes = self.orders[self.currentIndex]._categorySizes.map((c) => {
            return { value: c.name, explain: c.explain };
          });
        } else {
          sizes = self.sizes.map((c) => {
            return { value: c.name, explain: c.explain };
          });
        }
      }
      if (queryString == null) {
        cb(sizes);
      } else {
        cb(sizes.filter((c) => c.value.indexOf(queryString) !== -1));
      }
    },
    handleSelectSize(idx) {
      const self = this;
      self.orders[idx].size = Util.jyTrim(self.orders[idx].size);
      self.computeRemark(idx);
      self.computeCNYPrice(idx);
    },
    computeRemark(idx) {
      const self = this;
      const sizeObj = self.sizes.find((s) => s.name === self.orders[idx].size);
      // 替换已经有的尺码说明
      if (
        self.orders[idx].remark != null &&
        self.orders[idx]._oldSizeExplain != null
      ) {
        self.orders[idx].remark = self.orders[idx].remark.replace(
          ";【" + self.orders[idx]._oldSizeExplain + "】",
          ""
        );
        self.orders[idx].remark = self.orders[idx].remark.replace(
          "<br/>【" + self.orders[idx]._oldSizeExplain + "】",
          ""
        );
        self.orders[idx].remark = self.orders[idx].remark.replace(
          "【" + self.orders[idx]._oldSizeExplain + "】",
          ""
        );
        self.orders[idx].remark = self.orders[idx].remark.replace(
          self.orders[idx]._oldSizeExplain,
          ""
        );
      }
      // 加入新的尺码说明
      if (sizeObj != null && sizeObj.explain != null && sizeObj.explain != "") {
        if (self.orders[idx].remark !== null && self.orders[idx].remark != "") {
          self.orders[idx].remark =
            self.orders[idx].remark + ";【" + sizeObj.explain + "】";
        } else {
          self.orders[idx].remark = "【" + sizeObj.explain + "】";
        }
        self.orders[idx]._oldSizeExplain = sizeObj.explain;
      }
    },
    //
    blurPrice(idx) {
      if (
        this.orders[idx].productPrice != null &&
        this.orders[idx].productPrice !== 0 &&
        this.orders[idx].price != null
      ) {
        this.orders[idx].discountRate = Util.toFixed(
          (this.orders[idx].price / this.orders[idx].productPrice) * 100,
          3
        );
      }
      this.computeTotalAmount();
    },
    blurDiscountRate(idx) {
      if (
        this.orders[idx].discountRate == null ||
        !Util.regexQuantity(this.orders[idx].discountRate)
      ) {
        this.$message({
          message: this.$t("rules.regex", [this.$t("order.discountRate")]),
          type: "warning",
        });
        return;
      }
      if (this.orders[idx].productPrice != null) {
        this.orders[idx].price =
          this.orders[idx].productPrice * (this.orders[idx].discountRate / 100);
      }
    },
    getFoucs(index) {
      const self = this;
      self.currentIndex = index;
    },
    //
    getInvInfo(idx) {
      const self = this;
      self.invInfos = [];
      if (
        self.orders[idx].productNo != null &&
        self.orders[idx].productNo != ""
      ) {
        const obj = {
          productNo: self.orders[idx].productNo,
          color: self.orders[idx].color,
          size: self.orders[idx].size,
        };
        Inventory.findByProductInfoWithoutShop(obj).then(function (res) {
          if (res.status === 200) {
            self.invInfos = res.data;
          } else {
            self.sysError();
          }
        });
      }
    },
    //
    save(type) {
      let self = this;
      const obj = {
        bargainUuid: self.$route.query.bargainUuid,
        hurry: self.$route.query.hurry,
        handOverAt: self.$route.query.handOverAt,
        payBalance: self.$route.query.payBalance,
        customerBalance: self.$route.query.customerBalance,
        createAt: self.$route.query.createAt,
      };
      if (self.ignoreDF == true) {
        if (type == "bulk") {
          self.$router.go(0);
        } else {
          self.$router.push({
            path: "/normal/oms/bargains/new-" + type,
            query: obj,
          });
        }
        return;
      }
      if (!this.isImport) {
        const validOrders = JSON.parse(JSON.stringify(self.orders)).filter(
          (o) =>
            o.serialNo !== null &&
            o.serialNo !== "" &&
            o.productNo !== null &&
            o.productNo !== "" &&
            o.quantity !== null &&
            o.quantity !== ""
        );
        if (validOrders.length === 0) {
          self.$message.error(this.$t("prompt.atLeastOneValidDataFillIn"));
          return;
        }
        const orderSerialNos = validOrders.map((o) => o.serialNo);
        const orderSerialNosSet = [...new Set(orderSerialNos)];
        if (orderSerialNos.length !== orderSerialNosSet.length) {
          self.$message({
            message: self.$t("prompt.existSameOrderSerialNoLocal"),
            type: "warning",
          });
          return;
        }
        Order.findBySerialNos(orderSerialNosSet).then(function (res) {
          if (res.status == 200) {
            if (res.data.length !== 0) {
              const text =
                "有以下" + res.data.length + "条订单项号已存在:<br/><br/>";
              let detail = "";
              for (const data of res.data) {
                detail =
                  detail + "<div style='margin-bottom: 2px'>" + data + "<div>";
              }
              self.$message({
                dangerouslyUseHTMLString: true,
                message: text + detail,
                type: "warning",
              });
              return;
            }
            for (const o of validOrders) {
              if (!Util.regexPrice(o.price)) {
                self.$message({
                  message: self.$t("rules.regex", [self.$t("order.price")]),
                  type: "warning",
                });
                return;
              }
              if (!Util.regexQuantity(o.quantity) || o.quantity === "0") {
                self.$message({
                  message: self.$t("rules.regex", [self.$t("text.quantity")]),
                  type: "warning",
                });
                return;
              }
              o.bargainId = self.bargain.id;
              o.currency = self.bargain.currency;
              o.color = Util.jyTrim(o.color);
              o.size = Util.jyTrim(o.size);
              o.hurry = self.$route.query.hurry;
              o.handOverAt = self.$route.query.handOverAt;
              o.createAt = self.$route.query.createAt;
              if (
                o.productPrice == null ||
                o.productPrice === "0" ||
                o.productPrice == 0
              ) {
                o.productPrice = o.price;
              }
              if (self.bargain.settleType === "now") {
                o.settlementId = 0;
              }
              o.specJson = JSON.stringify(
                o._productNoAttributes.filter(
                  (c) => c.value !== null && c.value !== ""
                )
              );
            }
            //
            self.orderBatchInsertFunction(validOrders, type);
            //
          } else {
            self.sysError();
          }
        });
      } else {
        //导入
        if (self.importOrders.length === 0) {
          self.$message.error(this.$t("prompt.atLeastOneValidDataImport"));
          return;
        }
        if (self.importSameSerialNosLocalDF == true) {
          self.$message({
            message: self.$t("prompt.existSameOrderSerialNoLocal"),
            type: "warning",
          });
          return;
        }
        if (self.importSameSerialNosInvDF == true) {
          const text =
            "有以下" +
            self.importSameSerialNosInv.length +
            "条订单项号已存在:<br/><br/>";
          let detail = "";
          for (const data of self.importSameSerialNosInv) {
            detail =
              detail + "<div style='margin-bottom: 2px'>" + data + "<div>";
          }
          self.$message({
            dangerouslyUseHTMLString: true,
            message: text + detail,
            type: "warning",
          });
          return;
        }
        self.orderBatchInsertFunction(self.importOrders, type);
      }
    },
    orderBatchInsertFunction(data, type) {
      const self = this;
      const obj = {
        bargainUuid: self.bargain.uuid,
        hurry: self.$route.query.hurry,
        handOverAt: self.$route.query.handOverAt,
        createAt: self.$route.query.createAt,
        payBalance: self.$route.query.payBalance,
        customerBalance: self.$route.query.customerBalance,
        type: self.$route.query.type,
      };

      //　账户余额结算判断
      if (self.$route.query.payBalance == "true") {
        let currentOrdersAmount = 0;
        for (const d of data) {
          currentOrdersAmount =
            Number(currentOrdersAmount) +
            Number(
              Util.toFixed(
                Number(d.price * d.quantity) + Number(d.extraCharge),
                2
              )
            );
        }
        let amount =
          Number(self.bargain.amount || 0) + Number(currentOrdersAmount);
        if (amount > self.$route.query.customerBalance) {
          self.$message({
            message: self.$t("prompt.customerBalanceNotEnougth"),
            type: "warning",
          });
          return;
        }
      }
      //=====
      for (let o of data) {
        o.bargainId = self.bargain.id;
        o.currency = self.bargain.currency;
        o.color = Util.jyTrim(o.color);
        o.size = Util.jyTrim(o.size);
        o.hurry = self.$route.query.hurry;
        o.handOverAt = o.handOverAt;
        o.createAt = self.$route.query.createAt;
        if (o.productPrice == null || o.productPrice === "0") {
          o.productPrice = o.price;
        }
        if (self.bargain.settleType === "now") {
          o.settlementId = 0;
        }
      }
      self.saveDoing = true;
      if (
        type == "payment" &&
        self.bargain.orders.length == 0 &&
        data.length == 1 &&
        data[0].serialNo.indexOf(self.bargain.serialNo) == 0
      ) {
        data[0].serialNo = self.bargain.serialNo;
      }
      Order.insertBatch(data).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.saveSuccess"),
            type: "success",
          });
          if (type == "bulk") {
            self.$router.go(0);
          } else {
            self.$router.push({
              path: "/normal/oms/bargains/new-" + type,
              query: obj,
            });
          }
          self.$eventHub.$emit("orderNew");
        } else {
          self.sysError();
        }
        self.saveDoing = false;
      });
    },
  },
};
</script>
